import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
    useMemo
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './UserDetailsComponent.metadata.json5';
import styles from './UserDetailsComponent.module.scss';


const isSubtype = (contactDetails, subtype) => {
    return contactDetails.subtype.value === subtype;
};

function UserDetailsComponent(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        id,
        value: account,
        path: elementPath,
        contactPath,
        onValueChange,
        onValidate,
        labelPosition,
        showOptional,
        readOnly,
        nameReadonly,
        phone,
        phonewide
    } = props;
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const contactVM = useMemo(() => _.get(account, contactPath, {}), [account, contactPath]);
    const[workNumberNew,setWorkNumberNew]=useState(_.get(contactVM.accountContact,"workNumber.value"));
   
    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidate]);

    useEffect(()=>{
        setWorkNumberNew(_.get(contactVM.accountContact,"workNumber.value"))
    },[contactVM.accountContact])

    const onModelChange = useCallback(
        (model) => {
            onValueChange(model, `${elementPath}.${contactPath}`);
        },
        [contactPath, elementPath, onValueChange]
    );

    const updatePhoneNumber=(value)=>{
        _.set(contactVM.accountContact,"workNumber.value",value.phoneNumber);
        _.set(contactVM.billingContact,"workNumber.value",value.phoneNumber);
        setWorkNumberNew(value.phoneNumber);
    }

    useEffect(()=>{
        setWorkNumberNew(_.get(contactVM.accountContact,"workNumber.value"))
    },[contactVM.accountContact])

    const overrideProps = {
        '@field': {
            labelPosition,
            showOptional,
            readOnly,
            phone,
            phonewide,
            layout: breakpoint !== 'desktop' ? 'reversed' : ''
        },
        personFirstName: {
            readOnly: readOnly || nameReadonly
        },
        personLastName: {
            readOnly: readOnly || nameReadonly
        },
        addressLine1Id: {
            readOnly: readOnly || nameReadonly,
        },
        companyName: {
            readOnly: readOnly || nameReadonly
        },
        userdetailscity: {
            readOnly: readOnly || nameReadonly
        },
        Userzipcode: {
            readOnly: readOnly || nameReadonly
        },
        userdetailsstate: {
            readOnly: readOnly || nameReadonly
        },
        primaryPhoneField: {
            readOnly: readOnly || nameReadonly
        },
        personDetailsContainer: {
            visible: isSubtype(contactVM.accountContact, 'Person')
        },
        companyDetailsContainer: {
            visible: isSubtype(contactVM.accountContact, 'Company')
        },
        userdetailsemail:{
            showOptional:false
        },
        userdetailswork:{
            className:!readOnly && 'workNumber',
            onValueChange:(value)=>{updatePhoneNumber(value)},
            value: {
                "countryCode": {
                    "code": "us"
                },
                "phoneNumber": contactVM.accountContact.value.workNumber
            },
            dataType:"object"
        }
        
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={contactVM}
            overrideProps={overrideProps}
            onModelChange={onModelChange}
            onValidationChange={setComponentValidation}
            classNameMap={styles}
        />
    );
}

UserDetailsComponent.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.shape({}).isRequired,
    phonewide: PropTypes.shape({}),
    phone: PropTypes.shape({}),
    path: PropTypes.string.isRequired,
    contactPath: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    labelPosition: PropTypes.string.isRequired,
    showOptional: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool,
    nameReadonly: PropTypes.bool
};

UserDetailsComponent.defaultProps = {
    readOnly: false,
    nameReadonly: false,
    phonewide: undefined,
    phone: undefined
};

export default UserDetailsComponent;
